<template>
  <svg
    class="logo-divider"
    viewBox="0 0 2 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g transform="translate(-190.000000, -69.000000)">
      <g transform="translate(15.000000, 69.000000)">
        <polygon
          class="secondary"
          points="177 0.302197802 175 2.30154655 175 59.1133342 177 57.1227774"
        ></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'logo-divider'
};
</script>
